import api from "./axios";
import { useQuery } from "@tanstack/react-query";

/** Exponential backoff capped at 8s; React Query passes attempt index (0-based). */
const exponentialRetryDelay = (attempt) => Math.min(8000, 1000 * 2 ** attempt);

export const getDashboardStats = async () => {
  const response = await api.get("/dashboard");
  return response.data;
};

export const useDashboardCharts = () => {
  return useQuery({
    queryKey: ["dashboardCharts"],
    queryFn: () => api.get("/dashboard/charts").then(res => res.data),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: exponentialRetryDelay,
  });
};
export const useDashboardStats = () => {
  return useQuery({
    queryKey: ["dashboardStats"],
    queryFn: getDashboardStats,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: exponentialRetryDelay,
  });
};

export const getDashboardCharts = async () => {
  const response = await api.get("/dashboard/charts");
  return response.data;
};

export const useEmployeeSprintStatus = () => {
  return useQuery({
    queryKey: ["employeeSprintStatus"],
    queryFn: () => api.get("/dashboard/employee-sprint-status").then(res => res.data),
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: 2,
    retryDelay: exponentialRetryDelay,
  });
};

/** Manager / HR view of another member's sprint snapshot (same payload as IC dashboard). */
export const getEmployeeSprintStatusForUser = (userId) =>
  api.get('/dashboard/employee-sprint-status', { params: { userId } }).then((res) => res.data);

export const useMemberSprintStatus = (userId) =>
  useQuery({
    queryKey: ['employeeSprintStatus', userId],
    queryFn: () => getEmployeeSprintStatusForUser(userId),
    enabled: !!userId,
    staleTime: 60 * 1000,
    retry: 2,
    retryDelay: exponentialRetryDelay,
  });

export const useWeeklyProgress = () => {
  return useQuery({
    queryKey: ["weeklyProgress"],
    queryFn: () => api.get("/dashboard/weekly-progress").then(res => res.data),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: exponentialRetryDelay,
  });
};
